function getUser(): string {
    return window.Live.authorization.user.username
}
export { getUser }
